import React, { useContext, useState } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { callOutline, idCardOutline } from "ionicons/icons";
import { TranslationsContext } from "../util/Translations";

interface BuyerContactFieldProps {
  label?: string;
  code: string;
  name?: string;
  phone?: string;
  fax?: string;
}

// Bug 915967: the PO buyer is a validation code (sy_buyer) with its own
// name/phone/fax - NOT an employee. This card is fed directly from the sy_buyer
// data returned in the PO header, so it does NOT call the employee contact API.
// It behaves like the employee contact card (tap to open, one-tap call).
const openUri = (uri: string) => {
  window.open(uri, isPlatform("hybrid") ? "_system" : "_blank");
};

const BuyerContactField: React.FC<BuyerContactFieldProps> = ({
  label,
  code,
  name,
  phone,
  fax,
}) => {
  const { translations } = useContext(TranslationsContext);
  const [open, setOpen] = useState(false);
  const displayName = name || code;

  return (
    <>
      <IonItem button detail={false} onClick={() => setOpen(true)}>
        <IonLabel>
          <p>{label}</p>
          <h3>{displayName}</h3>
        </IonLabel>
        <IonIcon slot="end" icon={idCardOutline} color="primary" />
      </IonItem>
      <IonModal
        isOpen={open}
        onDidDismiss={() => setOpen(false)}
        initialBreakpoint={0.4}
        breakpoints={[0, 0.4, 0.6]}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>{displayName}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setOpen(false)}>
                {translations["lbl_btn_close"] || "Close"}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          {!!code && (
            <IonItem lines="full">
              <IonLabel>
                <p>{translations["lbl_po_buyer"] || "Buyer"}</p>
                <h3>{code}</h3>
              </IonLabel>
            </IonItem>
          )}
          {phone ? (
            <IonItem button detail={false} onClick={() => openUri(`tel:${phone}`)}>
              <IonIcon slot="start" icon={callOutline} color="primary" />
              <IonLabel>
                <p>{translations["lbl_phone"] || "Phone"}</p>
                <h3>{phone}</h3>
              </IonLabel>
            </IonItem>
          ) : (
            <IonItem lines="none">
              <IonLabel color="medium">
                {translations["lbl_po_no_buyer_contact"] ||
                  "No contact details available."}
              </IonLabel>
            </IonItem>
          )}
          {!!fax && (
            <IonItem lines="none">
              <IonLabel>
                <p>{translations["lbl_fax"] || "Fax"}</p>
                <h3>{fax}</h3>
              </IonLabel>
            </IonItem>
          )}
        </IonContent>
      </IonModal>
    </>
  );
};

export default BuyerContactField;
